/**
 * The product's name. It is the same in every language, so texts never spell it out:
 * they say `{{brand}}`, and every translation instance fills it in from here.
 */
export const brandName = 'Slotwise';
